import React, { FormEvent, useRef, useState } from "react";
import styled from "styled-components/macro";
import Dialog from "@fluentui/react/lib/Dialog";
import Button from "../../shared/Button";
import { ResourceStrings } from "../../../ResourceStrings";
import Flex from "../../shared/Flex";
import { Dropdown, IDropdownOption } from "@fluentui/react/lib/Dropdown";
import { RootPost, ChildPost } from "../../../RootPost";
import { NodeType } from "./RichNodeEditor";

export interface ConvertCommentDialogProps {
    comment: ChildPost;
    ticket: RootPost;
    isOpen: boolean;
    onSubmit: (convertTo: NodeType) => void;
    onDismiss?: () => void;
}

export default function ConvertCommentDialog(props: ConvertCommentDialogProps): JSX.Element {
    const [error, setError] = useState<string>(null);
    const refConvertBtn = useRef(null);
    const [selectedOption, setSelectedOption] = useState<NodeType>(null);

    const onDismiss = (): void => {
        setError(null);
        props.onDismiss();
    }

    return <DialogWrapper
        hidden={!props.isOpen}
        onDismiss={onDismiss}
        modalProps={{
            layerProps: {
                onLayerDidMount: () => {
                    setTimeout(() => {
                        refConvertBtn.current?.focus();
                    }, 100);
                }
            },
            isBlocking: false,
            styles: {
                main: {
                    border: `solid 2px gray`,
                    borderRadius: '.8rem',
                }
            }
        }}
        dialogContentProps={{
            showCloseButton: true,
            title: "Convert comment",
            closeButtonAriaLabel: ResourceStrings.close(),
        }}
    >
        <div
            id="notificationMessageReader"
            className="visually-hidden"
            role={"status"}
            aria-live="assertive"
        >
            Convert comment
        </div>

        <Flex column densityVer="relaxed">
            <Dropdown
                options={[{ key: NodeType.solution, text: "to a solution" }, { key: NodeType.workaround, text: "to a workaround" }]}
                placeholder="Please select an option"
                aria-label="Select conversion type"
                onChange={(event: FormEvent<HTMLDivElement>, item: IDropdownOption) => setSelectedOption(item.key as NodeType)}
            />

            {error && <div className="error">{error}</div>}
            <Flex justifyContent="flex-end" densityHor="normal">
                <Button onClick={onDismiss} buttonType="normal">Close</Button>
                <Button ref={refConvertBtn} onClick={() => props.onSubmit(selectedOption)}>Ok</Button>
            </Flex>
        </Flex>
    </DialogWrapper>
}

const DialogWrapper = styled(Dialog)`
    .ms-Dialog-main {
        min-width: 50rem;
        max-width: 90rem;
    }

    .ms-Dropdown-container {
        margin: 2rem .5rem;
    }

    .url {
        border: solid 1px var(--color-on-surface-lighter);
        padding: .5rem 1rem;
        margin-bottom: 3rem;
    }
`;
